import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");

// プリレンダリング済みのHTML（build/内の各index.html）には、
// あらかじめ描画済みのマークアップが入っている。
// その場合はcreateRoot(=作り直し)ではなくhydrateRoot(=引き継ぎ)を使うことで、
// クローラー向けの静的HTMLをそのまま活かしつつ、通常通り操作可能な状態にする。
// npm start等、まだ何も描画されていない場合は今まで通りcreateRootを使う。
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
